import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { EstadoPeriodo } from 'src/app/Models/planilla/estado-periodo';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-estado-periodo',
  templateUrl: './estado-periodo.component.html',
  styleUrls: ['./estado-periodo.component.css']
})
export class EstadoPeriodoComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: EstadoPeriodo[] = [];
  public nuevo: EstadoPeriodo   = new EstadoPeriodo();
  public agregando              = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Estados de Período | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.estado_periodo, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.estado_periodo);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new EstadoPeriodo(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new EstadoPeriodo(); }
  formNewValid(): boolean { return !!(this.nuevo.codigo && this.nuevo.nombre); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.estado_periodo, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new EstadoPeriodo(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: EstadoPeriodo)  { this._backup[item.idestado] = { ...item }; item.editando = true; }
  CancelEdit(item: EstadoPeriodo) { Object.assign(item, this._backup[item.idestado]); item.editando = false; }

  SaveEdit(item: EstadoPeriodo) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.estado_periodo, `${item.idestado}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idestado]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: EstadoPeriodo) {
    this.info.show(`¿Deseas eliminar el estado "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: EstadoPeriodo) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.estado_periodo, `${item.idestado}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
